var angular = require('angular');

var Count = require('js/lib/count');
var mapTooltipTemplate = require('html/templates/mapTooltip')();

var maxRoutesInColumn = 15;

function MapTooltipTemplate(scope, $compile) {
  this.scope = scope;
  this.$compile = $compile;
}

MapTooltipTemplate.prototype.compile = function(selectedFeature) {
  var template;

  this.scope.mapTooltip = this.initScope(selectedFeature, this.scope.routePlan);
  template = this.$compile(mapTooltipTemplate)(this.scope);
  this.scope.$apply();

  return template[0];
};

MapTooltipTemplate.prototype.initScope = function(selectedFeature, routePlan) {
  var features = selectedFeature.get('features') || [];

  var mapTooltip = {
    pickupLocation: selectedFeature.get('pickupLocation'),
    route: selectedFeature.get('route'),
    isCluster: features.length > 1,
    stops: features.map(function(feature) {
      return feature.get('stop');
    })
  };

  if (mapTooltip.pickupLocation) {
    mapTooltip.nrOfRouteNameColumns = function() {
      var routes = routePlan.routes.filter((function(route) {
        return route.pickupLocationId === mapTooltip.pickupLocation.id;
      }));
      return Math.ceil(routes.length / maxRoutesInColumn);
    };
  }

  if (mapTooltip.isCluster) {
    angular.extend(mapTooltip, new Count(mapTooltip.stops));
  }

  return mapTooltip;
};

module.exports = MapTooltipTemplate;



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/lib/map/mapTooltipTemplate.js
 ** module id = 183
 ** module chunks = 1
 **/